export default __webpack_public_path__ + "static/media/2634442.aa608852.jpg";